//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  setup() {
    const colorTooltipList = ['primary', 'secondary', 'success', 'info', 'warning', 'error']

    return { colorTooltipList }
  },
}
